import React from 'react';
import Header from '../components/Header';

function ThankYou() {
  return (
    <div className="public-container">
      <Header subtitle="Encuesta Completada" />
      <main className="thankyou-main">
        <div className="thankyou-card">
          <div className="thankyou-icon">✓</div>
          <h1 className="thankyou-title">¡Gracias por participar!</h1>
          <p className="thankyou-message">
            Tu opinión es muy valiosa para nosotros y nos ayudará a seguir
            mejorando el ambiente de trabajo en Bodegas Emilio Moro.
            <br /><br />
            Tus respuestas han sido registradas de forma anónima.
          </p>
          <div className="thankyou-signature">
            <div className="thankyou-sig-logo">EMILIO MORO</div>
            <div className="thankyou-sig-text">Bodegas</div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ThankYou;
